/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FAQ, FaqResponse} from 'src/components/models';
import ApiConfig from './ApiConfig';
import { ConsumerInformationClient_V1, InformationalVideoDTO, WebsiteContentLinkDTO } from './generated/api.generated.v1';
import axios from 'axios';

export default class ConsumerInformationService {
    private readonly _consumerInfoClient: ConsumerInformationClient_V1;

    constructor() {
        this._consumerInfoClient = new ConsumerInformationClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public GetDealerInformationalVideos(): Promise<Array<InformationalVideoDTO>> {
        return this._consumerInfoClient.dealerVideos();
    }

    public WebsiteContentLinks(): Promise<WebsiteContentLinkDTO> {
        return this._consumerInfoClient.websiteContentLinks();
    }

    public async FrequentlyAskedQuestions(postsUrl: string): Promise<FAQ | null> {
        if (!postsUrl) {
            return null;
        }

        const mapper = (data: FaqResponse) => {
            const faq = new FAQ();
            faq.title = data.yoast_head_json.og_title;

            const categories = data.acf.faq_category.map(x => {
                return {
                    title: x.category_title,
                    questions: x.faq.map(x => { return { question: x.question, answerContent: x.answer } }
                    )
                };
            })
            faq.categories = categories
            faq.glossary = data.acf.glossary_entry.map(x => { return { term: x.term, definition: x.definition } });

            return faq;
        }

        return await this.GetData<FAQ | null>(postsUrl, mapper);

    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private async GetData<TResult>(url: string, mapper: (res: any) => TResult): Promise<TResult | null> {
        return new Promise<TResult | null>((resolve, reject) => {
            if (!url) {
                resolve(null);
            }

            const makeWebApiCall = () => {
                axios.get<TResult>(url)
                    .then(resp => {
                        const results = mapper(resp.data);
                        resolve(results);
                    })
                    .catch((er) => {
                        reject(er);
                    });
            }

            makeWebApiCall();
        })
    }
}